/// <amd-module name="Wit/Common/Utilities/FormatUtils" />
import { format } from "VSS/Core/Util/String";
import { getPageContext } from "VSS/Platform/Context";
import { ICultureInfo, getInvariantCulture } from "Wit/Common/Culture";

export function formatRemainingWorkForDisplay(remainingWorkValue: number) {
    return getNumberInUserFormat(remainingWorkValue, MaximumFractionDigits);
}

export function getNumberInUserFormat(fieldValue: number | undefined | null, maximumFractionDigits?: number): string {
    if (!fieldValue && fieldValue !== 0) {
        return "";
    }
   
    let fractionDigitsToUse = undefined;

    if (Math.abs(fieldValue) < 1.0) {
        var exponentValueInScientificNotation = parseInt(fieldValue.toString().split('e-')[1]);
        if (exponentValueInScientificNotation <= 20) {
            fractionDigitsToUse = exponentValueInScientificNotation;
        }
    }

    const currentCulture = getCurrentCultureFromLegacyContext();
    const invariantCulture = getInvariantCulture();
    const invariantDecimalSeparator = invariantCulture.numberFormat.NumberDecimalSeparator;
    const localeDecimalSeparator = currentCulture.numberFormat.NumberDecimalSeparator;
    let newValue = fieldValue.toString();
    if (maximumFractionDigits) {
        const numberFormatRegexp: any = new RegExp("(\\" + invariantDecimalSeparator + "0*|0+)$");
        const thousandSeparatorRegexp: any = new RegExp("\\" + invariantCulture.numberFormat.NumberGroupSeparator, "g");
        newValue = format("{0:n" + MaximumFractionDigits + "}", fieldValue).replace(numberFormatRegexp, '').replace(thousandSeparatorRegexp, '');
    }
    else if (fractionDigitsToUse) {
        newValue = fieldValue.toFixed(fractionDigitsToUse);
    }

    const result = newValue.replace(invariantDecimalSeparator, localeDecimalSeparator);
    return result;
}

export function getCurrentCultureFromLegacyContext(): ICultureInfo {
    const legacyPageContext = getPageContext("ms.vss-web.legacy-platform-data-provider");
    let currentCulture: ICultureInfo;
    const msAjaxConfig = legacyPageContext?.microsoftAjaxConfig;
    if (msAjaxConfig && msAjaxConfig.cultureInfo) {
        currentCulture = msAjaxConfig.cultureInfo;
        if (msAjaxConfig.cultureInfo.eras) {
            currentCulture.dateTimeFormat.eras = msAjaxConfig.cultureInfo.eras;
        }
    } else {
        currentCulture = getInvariantCulture();
    }
    return currentCulture;
}

export const MaximumFractionDigits = 3;
export const DefaultNumberFormatOptions: Intl.NumberFormatOptions = { maximumFractionDigits: MaximumFractionDigits, useGrouping: false };
